import {createStyles, Stack} from '@mantine/core';
import React from 'react';

import {ProcedureRunTab} from 'studies/redux/ProcedureRunPlanUIReduxActions';
import {Tab, TabContainer} from 'ui-library/TabContainer';

import {type StudyExecutionHeaderTabsProps} from './StudyExecutionHeader';

interface ProcedureRunLayoutProps {
  header: React.ReactNode;
  tabProps: StudyExecutionHeaderTabsProps<ProcedureRunTab>;
  execution: React.ReactNode;
}

export default function ProcedureRunLayout({
  header,
  tabProps,
  execution,
}: ProcedureRunLayoutProps): JSX.Element {
  const {classes} = useStyles();
  return (
    <Stack spacing={0} className={classes.container}>
      {header}
      {tabProps.headerTabContainerProps ? (
        <TabContainer {...tabProps.headerTabContainerProps}>
          {tabProps.headerTabsProps.map((headerTabProps) => (
            <Tab key={headerTabProps.tabKey} {...headerTabProps}>
              {execution}
            </Tab>
          ))}
        </TabContainer>
      ) : (
        <div className={classes.execution}>{execution}</div>
      )}
    </Stack>
  );
}

const useStyles = createStyles((theme) => ({
  container: {
    height: '100%',
    width: '100%',
  },
  execution: {
    backgroundColor: theme.colors.gray[0],
    height: '100%',
    maxHeight: '100%',
  },
}));
